import { ADPTags } from '@services/types';

export interface Messenger {
    send: (messagingTable: string, error?: Error, tags?: ADPTags) => void;
    sendPasskeyEvent: (message: Partial<PasskeyEventMessage>) => void;
    trackSocialLoginImpression: (userId: string) => void;
    trackSocialLoginAttempt: (userId: string, socialType: string) => void;
    trackSocialLoginConversion: (userId: string, socialType: string, success: boolean, error?: string) => void;
}

export interface UalCaptchaAnalyticMessage {
    application_name: string;
    app_id: string;
    origin: string;
    session_id: string;
    user_id: string;
    white_label_id: number;
    correlation_id: string;
    captcha_session_id: string;
    captcha_type: string;
    captcha_id: string;
    captcha_event: string;
    duration: number;
    error_message?: string;
}

export enum PasskeyOperation {
    REGISTRATION = 'registration',
    AUTHENTICATION = 'authentication',
    UNKNOWN = 'unknown',
}

export enum PasskeyEventName {
    REGISTRATION_LOCAL_INIT = 'passkey_registration_local_init',
    REGISTRATION_LOCAL_SUCCESS = 'passkey_registration_local_success',
    REGISTRATION_LOCAL_ERROR = 'passkey_registration_local_error',
    REGISTRATION_LOCAL_CANCEL = 'passkey_registration_local_cancel',
    REGISTRATION_LOCAL_NOT_NOW = 'passkey_registration_local_not_now',
    REGISTRATION_LOCAL_BACK = 'passkey_registration_local_back',
    REGISTRATION_ULSDK_RESPONSE_SUCCESS = 'passkey_registration_ulsdk_response_success',
    REGISTRATION_ULSDK_RESPONSE_ERROR = 'passkey_registration_ulsdk_response_error',
    AUTHENTICATION_LOCAL_INIT = 'passkey_authentication_local_init',
    AUTHENTICATION_LOCAL_SUCCESS = 'passkey_authentication_local_success',
    AUTHENTICATION_LOCAL_ERROR = 'passkey_authentication_local_error',
    AUTHENTICATION_LOCAL_USER_CANCEL = 'passkey_authentication_local_user_cancel',
    AUTHENTICATION_LOCAL_NO_CREDENTIAL = 'passkey_authentication_local_no_credential',
    AUTHENTICATION_LOCAL_ABORT = 'passkey_authentication_local_abort',
    AUTHENTICATION_ULSDK_RESPONSE_SUCCESS = 'passkey_authentication_ulsdk_response_success',
    AUTHENTICATION_ULSDK_RESPONSE_ERROR = 'passkey_authentication_ulsdk_response_error',
    UNKNOWN = 'unknown',
}

export enum PasskeyTriggerSource {
    LOGIN = 'login',
    SETTINGS_FLOW = 'profile',
    PASSWORD_LOGIN = 'password_login',
}

export enum PasskeyErrorCategory {
    SYSTEM_ERROR = 'system_error',
    USER_ACTION = 'user_action',
}

export interface PasskeyEventMessage {
    user_id: string;
    member_id: number | null;
    application_type: string;
    app_version: string | null;
    os_version: string | null;
    operation: PasskeyOperation;
    event_name: PasskeyEventName;
    response_code: string | null;
    note: string | null;
    trigger_source: PasskeyTriggerSource | null;
    metadata: string | null;
    error_code: string | null;
    error_description: string | null;
    error_category: PasskeyErrorCategory | null;
    timestamp: number;
}
